const { VEHICLE_REGISTRATION_METHOD } = require("../../constants");
const { getVehicleRegistrationType } = require("./getVehicleRegistrationType");

// Accepts any vehicleRegistration shape (canonical { type: string }, legacy bare string,
// or a corrupt value) via getVehicleRegistrationType, which resolves it to the canonical
// registration-type string (defaulting present-but-unresolvable nonsense to Citroën).
const getIsVehicleRegistrationByCitroenSelected = registrationType =>
  getVehicleRegistrationType(registrationType) ===
  VEHICLE_REGISTRATION_METHOD.CITROEN;

module.exports = { getIsVehicleRegistrationByCitroenSelected };
